import { Component, ViewChild } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ValidatePermissionsService } from '../../services/validate-permissions.service';
import { ConfigurationsCustomerComponent } from '../configurations-customer/configurations-customer.component';
import { SidebarService } from 'src/app/services/sidebar.service';

import { CommonModule } from '@angular/common';
import { CustomerService } from '../../../services/customer.service';
import { UserDTO } from '../../../models/UserDTO.model';
@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css'],
    imports: [CommonModule, RouterModule, ConfigurationsCustomerComponent]
})
export class SidebarComponent {
  @ViewChild(ConfigurationsCustomerComponent) configurationsModal!: ConfigurationsCustomerComponent;

  sidebarOpen = false; // Controla si el sidebar está abierto o no en móviles
  canSendSMS: boolean = false;

  public currentUser?: UserDTO;
  public currentUserDisplayName?: string;
  constructor(
    private router: Router,
    public permisionsService: ValidatePermissionsService,
    public sidebarService: SidebarService,
    public customerService: CustomerService
  ) {}

ngOnInit() {

  this.sidebarService.CanSendSMS().subscribe(
    (data) => {

      this.canSendSMS = data.canSendSMS;

    },
    (error) => {});

    const x = this.customerService.getCurrentUser().subscribe(
      ({ StatusCode, Message, Data }) => {
        if (Data != null) {
          this.currentUser = Data;
          if (this.currentUser) {
            if (this.currentUser.userNames != this.currentUser.userMail) {
              this.currentUserDisplayName = `${this.currentUser.userNames} (${this.currentUser.userMail})`;
            } else {
              this.currentUserDisplayName = this.currentUser.userNames;
            }
          } else {
            this.currentUserDisplayName = '';
          }
        }
      },
      (error) => {
      }
    );
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/login']);
  }


  roleExists(role: string): boolean {
    return this.permisionsService.roleExists(role);
  } 

  public get getCustomersRoute(): string {
    if (this.permisionsService.isCustomerLevel) {
      const userId = this.permisionsService.customerId ?? this.permisionsService.userId;
      return `/customers/customer-account/${userId}`;
    }
    return '/customers';
  }

  public get getDistributorsRoute(): string {
    if (this.permisionsService.isDistributorLevel) {
      const userId = this.permisionsService.distributorId ?? this.permisionsService.userId;
      return `/distributors/distributor-account/${userId}`;
    }
    return this.permisionsService.isAdmin ? '/distributors' : '';
  }

  isActive(route: string): boolean {
    return this.router.url === route;
  }

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
  }

  headerSidebar() {
    this.sidebarOpen = false;
  }

  // openConfigurations(): void {
  //   this.configurationsModal.openModal(); // Llamamos al método para abrir el modal
  // }
}
